import React from "react";
import { Alert, Badge, Button, Card, Col, Form, Row } from "react-bootstrap";
import Footer from "../components/Footer";

const Quiz = () => {
  return (
    <>
      <Row className="mx-0 all-courses">
        <Col md={9}>
          <Card className="shadow">
            <Card.Body>
              <h6>Welcome to HT Academy Quiz.</h6>
              <p>
                We are going to post daily (Monday - Friday) 5-10 questions on
                aptitude, logical thinking and program questions.
              </p>
              <h5>Today Quiz Questions</h5>
              <Alert variant="secondary">
                <p className="fw-bold mb-0">
                  1. Which one of the following is not a prime number?
                </p>
                <Form.Group className="m-2">
                  <Form.Check
                    type="radio"
                    inline
                    name="ans1"
                    label="31"
                    id="a1"
                  />
                  <Form.Check
                    type="radio"
                    inline
                    name="ans1"
                    label="61"
                    id="a2"
                  />
                  <Form.Check
                    type="radio"
                    inline
                    name="ans1"
                    label="71"
                    id="a3"
                  />
                  <Form.Check
                    type="radio"
                    inline
                    name="ans1"
                    label="91"
                    id="a4"
                  />
                  <Form.Check
                    type="radio"
                    inline
                    name="ans1"
                    label="27"
                    id="a5"
                  />
                </Form.Group>
                <hr />
                <p className="fw-bold mb-0">
                  2. What are the New tags in Media Elements in HTML5?
                </p>
                <Form.Group className="m-2">
                  <Form.Check
                    type="radio"
                    inline
                    name="ans2"
                    label="audio"
                    id="q1"
                  />
                  <Form.Check
                    type="radio"
                    inline
                    name="ans2"
                    label="video"
                    id="q2"
                  />
                  <Form.Check
                    type="radio"
                    inline
                    name="ans2"
                    label="source"
                    id="q3"
                  />
                  <Form.Check
                    type="radio"
                    inline
                    name="ans2"
                    label="embed"
                    id="q4"
                  />
                  <Form.Check
                    type="radio"
                    inline
                    name="ans2"
                    label="all"
                    id="q5"
                  />
                </Form.Group>{" "}
                <hr />
                <p className="fw-bold mb-0">
                  3. (112 x 5<sup>4</sup>) = ?
                </p>
                <Form.Group className="m-2">
                  <Form.Check
                    type="radio"
                    inline
                    name="ans2"
                    label="67000"
                    id="p1"
                  />
                  <Form.Check
                    type="radio"
                    inline
                    name="ans2"
                    label="70000"
                    id="p2"
                  />
                  <Form.Check
                    type="radio"
                    inline
                    name="ans2"
                    label="76500"
                    id="p3"
                  />
                  <Form.Check
                    type="radio"
                    inline
                    name="ans2"
                    label="77200"
                    id="p4"
                  />
                  <Form.Check
                    type="radio"
                    inline
                    name="ans2"
                    label="none"
                    id="p5"
                  />
                </Form.Group>{" "}
                <hr />
                <p className="fw-bold mb-0">
                  4. Which of the following is Pseudo-class?
                </p>
                <Form.Group className="m-2">
                  <Form.Check
                    type="radio"
                    inline
                    name="ans2"
                    label="::hover"
                    id="g1"
                  />
                  <Form.Check
                    type="radio"
                    inline
                    name="ans2"
                    label=":active"
                    id="g2"
                  />
                  <Form.Check
                    type="radio"
                    inline
                    name="ans2"
                    label="::link"
                    id="g3"
                  />
                  <Form.Check
                    type="radio"
                    inline
                    name="ans2"
                    label=":div.p"
                    id="g4"
                  />
                  <Form.Check
                    type="radio"
                    inline
                    name="ans2"
                    label="all"
                    id="g5"
                  />
                </Form.Group>{" "}
                <hr />
                <p className="fw-bold mb-0">
                  5. What least number must be added to 1056, so that the sum is
                  completely divisible by 23 ?
                </p>
                <Form.Group className="m-2">
                  <Form.Check
                    type="radio"
                    inline
                    name="ans2"
                    label="2"
                    id="k1"
                  />
                  <Form.Check
                    type="radio"
                    inline
                    name="ans2"
                    label="3"
                    id="k2"
                  />
                  <Form.Check
                    type="radio"
                    inline
                    name="ans2"
                    label="18"
                    id="k3"
                  />
                  <Form.Check
                    type="radio"
                    inline
                    name="ans2"
                    label="21"
                    id="k4"
                  />
                  <Form.Check
                    type="radio"
                    inline
                    name="ans2"
                    label="None"
                    id="k5"
                  />
                </Form.Group>{" "}
                <Button variant="success" className="px-5 mt-2" size="sm">
                  Submit Quiz
                </Button>
                <Button
                  variant="success"
                  className="px-5 mt-2 ms-2"
                  disabled
                  size="sm"
                >
                  Show Answers
                </Button>
              </Alert>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} className="px-0">
          <Card className="shadow">
            <Card.Body>
              <h4 className="d-flex justify-content-between align-items-center mb-0">
                <span>Your total score: </span>
                <span className="fs-3 px-2 py-1 fw-bold">0</span>
              </h4>
              <h6 className="d-flex justify-content-between align-items-center text-primary mb-0">
                <span>Today total score: </span>
                <span className="fs-5 px-2 py-1 fw-bold">0</span>
              </h6>
              <h6 className="d-flex justify-content-between align-items-center mb-0 text-success">
                <span>Total correct answers: </span>
                <span className="fs-5 px-2 py-1 fw-bold">0</span>
              </h6>
              <h6 className="d-flex justify-content-between align-items-center text-danger">
                <span>Total wrong answers: </span>
                <span className="fs-5 px-2 py-1 fw-bold">0</span>
              </h6>
            </Card.Body>
            <Card.Footer>
              <Button variant="danger" className="w-100" size="sm" disabled>
                Quiz contest
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
      <Footer />
    </>
  );
};

export default Quiz;
